const materials = {
  // HeroSection
  'materials.hero.homeLink': 'ホーム',
  'materials.hero.aboutLink': 'アカデミーについて',
  'materials.hero.currentPage': '使用教材',
  'materials.hero.title': '使用教材',
  'materials.hero.titleEn': 'MATERIALS',
  'materials.hero.lead': '学びを支えるのは、協会監修による体系的な教科書群です。在学中の学びだけでなく、卒業後も長く手元で参照できる一生ものの資料として編まれています。日本の執事学校である日本執事アカデミーでは、これらの教材を通じて実践的な執事養成を支えています。',
  'materials.hero.imgAlt': '全日本執事協会監修の執事教科書全15冊を並べた表紙の様子',

  // MaterialPhilosophy
  'materials.philosophy.label': 'OUR APPROACH',
  'materials.philosophy.title': '教材の考え方',
  'materials.philosophy.titleEn': 'Our Approach to Materials',
  'materials.philosophy.description1': '教材は、在学中だけのものではありません。実務に直結する事例を豊富に収め、卒業後も長く参照できる一生ものの資料として編まれています。協会の知見を結集し、執事という職業の本質を学問として体系化した、日本で唯一の本格的な執事育成機関ならではの教科書群です。日本の執事文化を伝える執事学校として、学問と実務の両面から編まれています。',
  'materials.philosophy.description2': '授業では、教科書の該当箇所を事前学習としてご案内し、対面の時間を実技と質疑に充てる反転学習的な進め方を取り入れています。また、卒業生が実務で参照することを想定し、索引や用語集の充実を教材設計の方針としています。なお、電子版（PDF）のご提供につきましては、現在検討中です。',
  'materials.philosophy.card.0.title': '事前学習の重視',
  'materials.philosophy.card.0.text': '教科書の該当箇所を事前に読み、対面では実技と質疑に集中する反転学習を取り入れています。',
  'materials.philosophy.card.1.title': '索引・用語集の充実',
  'materials.philosophy.card.1.text': '卒業後も実務の場で素早く参照できるよう、索引と用語集を充実させる方針で編まれています。',
  'materials.philosophy.card.2.title': '電子版（PDF）',
  'materials.philosophy.card.2.text': '電子版のご提供については現在検討中です。詳細が決まり次第お知らせします。',

  // TextbookLineup
  'materials.books.label': 'TEXTBOOKS',
  'materials.books.title': '教科書ラインナップ',
  'materials.books.titleEn': 'Textbook Lineup',
  'materials.books.description': '協会監修の教科書は全15冊（基礎のE群・応用のA群・専門のM群、各5冊）。執事の歴史から家政管理、国際プロトコル、VVIPサービスまで、執事に必要な知識を体系的に網羅します。',
  'materials.books.imgNote': '※教科書の表紙デザインはイメージであり、実際のものとは異なる場合があります',

  // TextbookLineup groups (E/A/M, 5 books each)
  'materials.books.groups.0.title': 'E群 基礎教科書（全コース共通・5冊）',
  'materials.books.groups.0.note': '全コース共通で提供',
  'materials.books.groups.1.title': 'A群 応用教科書（アドバンス・マスター・5冊）',
  'materials.books.groups.1.note': 'アドバンスはE群5冊も提供（計10冊）',
  'materials.books.groups.2.title': 'M群 専門教科書（マスター限定・5冊）',
  'materials.books.groups.2.note': 'マスターは全15冊を提供',
  'materials.books.groups.0.books.0.code': 'E1',
  'materials.books.groups.0.books.0.title': '執事学入門：歴史・文化・職業倫理',
  'materials.books.groups.0.books.0.titleEn': 'Introduction to Butlering: History, Culture & Professional Ethics',
  'materials.books.groups.0.books.0.description': '英国発祥の執事文化の歴史から現代に至るまでの変遷、執事としての職業倫理と心構えを学ぶ入門書。全コース共通の基本テキストです。',
  'materials.books.groups.0.books.0.imgAlt': '『E1 執事学入門：歴史・文化・職業倫理』の教科書。アンティークの書斎机に置かれた革装丁の一冊',
  'materials.books.groups.0.books.1.code': 'E2',
  'materials.books.groups.0.books.1.title': 'ハウスキーピングの理論と実践',
  'materials.books.groups.0.books.1.titleEn': 'Housekeeping Theory & Practice',
  'materials.books.groups.0.books.1.description': '邸宅の清掃・洗濯・衣類管理から家政運営の基礎理論まで、ハウスキーピングの実務を体系的に学ぶ一冊です。',
  'materials.books.groups.0.books.1.imgAlt': '『E2 ハウスキーピングの理論と実践』の教科書。アンティークの書斎机に置かれた革装丁の一冊',
  'materials.books.groups.0.books.2.code': 'E3',
  'materials.books.groups.0.books.2.title': 'サービスの基本とおもてなしの心',
  'materials.books.groups.0.books.2.titleEn': 'Fundamentals of Service & the Spirit of Hospitality',
  'materials.books.groups.0.books.2.description': 'テーブルマナー、来客応対、おもてなしの精神を軸に、サービスの基本所作を身につける実践テキストです。',
  'materials.books.groups.0.books.2.imgAlt': '『E3 サービスの基本とおもてなしの心』の教科書。アンティークの書斎机に置かれた革装丁の一冊',
  'materials.books.groups.0.books.3.code': 'E4',
  'materials.books.groups.0.books.3.title': 'コミュニケーションとビジネスマナー',
  'materials.books.groups.0.books.3.titleEn': 'Communication & Business Etiquette',
  'materials.books.groups.0.books.3.description': '敬語・言葉遣いから電話応対、ビジネス文書まで、執事に求められる対人スキルとマナーを網羅します。',
  'materials.books.groups.0.books.3.imgAlt': '『E4 コミュニケーションとビジネスマナー』の教科書。アンティークの書斎机に置かれた革装丁の一冊',
  'materials.books.groups.0.books.4.code': 'E5',
  'materials.books.groups.0.books.4.title': '英国紳士の教養とたしなみ',
  'materials.books.groups.0.books.4.titleEn': 'The English Gentleman\'s Refinement',
  'materials.books.groups.0.books.4.description': '英国紳士文化に根差した教養、身だしなみ、会話術など、品格あるたしなみを学ぶ一冊です。',
  'materials.books.groups.0.books.4.imgAlt': '『E5 英国紳士の教養とたしなみ』の教科書。アンティークの書斎机に置かれた革装丁の一冊',
  'materials.books.groups.1.books.0.code': 'A1',
  'materials.books.groups.1.books.0.title': '家政管理と財務運営',
  'materials.books.groups.1.books.0.titleEn': 'Household Administration & Financial Management',
  'materials.books.groups.1.books.0.description': '家計簿・予算管理から外部業者との折衝まで、邸宅運営における財務・家政管理の実務を学びます。',
  'materials.books.groups.1.books.0.imgAlt': '『A1 家政管理と財務運営』の教科書。銀のティーセットが並ぶ書斎机に置かれた革装丁の一冊',
  'materials.books.groups.1.books.1.code': 'A2',
  'materials.books.groups.1.books.1.title': 'ビジネスサポートと秘書業務',
  'materials.books.groups.1.books.1.titleEn': 'Business Support & Secretarial Duties',
  'materials.books.groups.1.books.1.description': 'スケジュール管理、文書作成、来客対応など、雇主のビジネスを支える秘書的実務を体系化しています。',
  'materials.books.groups.1.books.1.imgAlt': '『A2 ビジネスサポートと秘書業務』の教科書。銀のティーセットが並ぶ書斎机に置かれた革装丁の一冊',
  'materials.books.groups.1.books.2.code': 'A3',
  'materials.books.groups.1.books.2.title': '食事サービスとテーブルマナー',
  'materials.books.groups.1.books.2.titleEn': 'Dining Service & Table Manners',
  'materials.books.groups.1.books.2.description': 'フォーマルディナーの提供手順、ワイン・ティーサービス、テーブルコーディネートを学ぶ実践書です。',
  'materials.books.groups.1.books.2.imgAlt': '『A3 食事サービスとテーブルマナー』の教科書。銀のティーセットが並ぶ書斎机に置かれた革装丁の一冊',
  'materials.books.groups.1.books.3.code': 'A4',
  'materials.books.groups.1.books.3.title': 'イベント企画と空間演出',
  'materials.books.groups.1.books.3.titleEn': 'Event Planning & Spatial Design',
  'materials.books.groups.1.books.3.description': 'パーティーやレセプションの企画運営、空間演出、装花・照明までを扱う応用テキストです。',
  'materials.books.groups.1.books.3.imgAlt': '『A4 イベント企画と空間演出』の教科書。銀のティーセットが並ぶ書斎机に置かれた革装丁の一冊',
  'materials.books.groups.1.books.4.code': 'A5',
  'materials.books.groups.1.books.4.title': 'ライフスタイル管理と特別サポート',
  'materials.books.groups.1.books.4.titleEn': 'Lifestyle Management & Special Support',
  'materials.books.groups.1.books.4.description': '雇主の日常生活全般のマネジメントと、個別ニーズに応じた特別なサポート技術を学びます。',
  'materials.books.groups.1.books.4.imgAlt': '『A5 ライフスタイル管理と特別サポート』の教科書。銀のティーセットが並ぶ書斎机に置かれた革装丁の一冊',
  'materials.books.groups.2.books.0.code': 'M1',
  'materials.books.groups.2.books.0.title': '国際プロトコルと各国文化',
  'materials.books.groups.2.books.0.titleEn': 'International Protocol & Cross-Cultural Understanding',
  'materials.books.groups.2.books.0.description': '各国の外交儀礼・文化的タブー・国際的なマナーを収録し、グローバルに活躍する知識を提供します。',
  'materials.books.groups.2.books.0.imgAlt': '『M1 国際プロトコルと各国文化』の教科書。地球儀と天秤が並ぶ書斎机に置かれた革装丁の一冊',
  'materials.books.groups.2.books.1.code': 'M2',
  'materials.books.groups.2.books.1.title': '社交技術とエスコート',
  'materials.books.groups.2.books.1.titleEn': 'Social Skills & Escort Technique',
  'materials.books.groups.2.books.1.description': '社交の場でのふるまい、エスコート技術、会話術など、上級執事に求められる社交スキルを学びます。',
  'materials.books.groups.2.books.1.imgAlt': '『M2 社交技術とエスコート』の教科書。地球儀と天秤が並ぶ書斎机に置かれた革装丁の一冊',
  'materials.books.groups.2.books.2.code': 'M3',
  'materials.books.groups.2.books.2.title': 'トラベルサポートと移動管理',
  'materials.books.groups.2.books.2.titleEn': 'Travel Support & Transportation Management',
  'materials.books.groups.2.books.2.description': '旅程の手配から車両・移動手段の管理まで、雇主の移動を支えるトラベルサポートの実務を学びます。',
  'materials.books.groups.2.books.2.imgAlt': '『M3 トラベルサポートと移動管理』の教科書。地球儀と天秤が並ぶ書斎机に置かれた革装丁の一冊',
  'materials.books.groups.2.books.3.code': 'M4',
  'materials.books.groups.2.books.3.title': '危機管理とトラブル対応',
  'materials.books.groups.2.books.3.titleEn': 'Crisis Management & Incident Response',
  'materials.books.groups.2.books.3.description': '医療緊急時、自然災害、セキュリティ事案など、邸宅で起こりうる危機への対応力を養います。',
  'materials.books.groups.2.books.3.imgAlt': '『M4 危機管理とトラブル対応』の教科書。地球儀と天秤が並ぶ書斎机に置かれた革装丁の一冊',
  'materials.books.groups.2.books.4.code': 'M5',
  'materials.books.groups.2.books.4.title': 'VVIPサービスとマネジメント',
  'materials.books.groups.2.books.4.titleEn': 'VVIP Service & Management',
  'materials.books.groups.2.books.4.description': '最上級の顧客層に向けたサービス設計とスタッフマネジメント、執事としての総合力を極める最終巻です。',
  'materials.books.groups.2.books.4.imgAlt': '『M5 VVIPサービスとマネジメント』の教科書。地球儀と天秤が並ぶ書斎机に置かれた革装丁の一冊',
  // CourseMaterialsTable
  'materials.table.label': 'BY COURSE',
  'materials.table.title': 'コース別の使用教材',
  'materials.table.titleEn': 'Textbooks by Course',
  'materials.table.description': 'コースにより使用する教科書の冊数が異なります。教材費はすべて受講料に含まれており、別途のご負担はありません。',
  'materials.table.col.course': 'コース',
  'materials.table.col.pages': '使用冊数',
  'materials.table.col.textbooks': '使用教材',
  'materials.table.col.note': '備考',
  'materials.table.col.detail': '',
  'materials.table.mobileLabel.textbooks': '使用教材',
  'materials.table.mobileLabel.note': '備考',
  'materials.table.viewCourse': 'コース詳細を見る',
  'materials.table.viewDetail': '詳細',
  'materials.table.footerNote': '※教材費はすべて受講料に含まれています。別途のご負担はありません。',
  'materials.table.0.name': 'エッセンシャル',
  'materials.table.0.pages': '5冊',
  'materials.table.0.textbooks': 'E1〜E5',
  'materials.table.0.note': '入門に必要な基礎知識をE群5冊で凝縮',
  'materials.table.1.name': 'アドバンス',
  'materials.table.1.pages': '計10冊',
  'materials.table.1.textbooks': 'E1〜E5, A1〜A5',
  'materials.table.1.note': '実務に直結するA群5冊を加え専門性を強化',
  'materials.table.2.name': 'マスター',
  'materials.table.2.pages': '全15冊',
  'materials.table.2.textbooks': 'E1〜E5, A1〜A5, M1〜M5',
  'materials.table.2.note': '教材全15冊で最高水準の知識を網羅',

  // MaterialUpdates
  'materials.updates.label': 'UPDATES',
  'materials.updates.title': '教材の更新',
  'materials.updates.titleEn': 'Updates & Revisions',
  'materials.updates.description': '協会監修の教科書は、定期的に内容を見直し、最新の知見や事例を反映していく予定です。社会の変化やサービスの潮流を踏まえ、常に最良の学びを提供できるよう努めてまいります。改訂時期や内容の詳細は、確定し次第お知らせページにてご案内します。',
  'materials.updates.inlineNote': '改訂時期や内容の詳細は、確定し次第',
  'materials.updates.inlineNoteLink': 'お知らせページ',
  'materials.updates.inlineNoteSuffix': 'にてご案内いたします。',
  'materials.updates.imgAlt': '執事教科書を広げて講師が解説する講義の様子',
  'materials.updates.imgCaption': '演習で教科書を参照する受講生',

  // FAQSection
  'materials.faq.label': 'FAQ',
  'materials.faq.title': 'よくあるご質問',
  'materials.faq.titleEn': 'Frequently Asked Questions',
  'materials.faq.footer': 'その他のご質問は',
  'materials.faq.footerContact': 'お問い合わせ',
  'materials.faq.footerSuffix': 'よりお寄せください',
  'materials.faq.0.question': '教材は何冊ありますか？',
  'materials.faq.0.answer': '協会監修の教科書が全15冊あります。エッセンシャルはE群5冊、アドバンスはE群+A群の計10冊、マスターは全15冊を使用します。',
  'materials.faq.1.question': '教材費は別途かかりますか？',
  'materials.faq.1.answer': '教材費は受講料に含まれています（別途のご負担はありません）。',
  'materials.faq.2.question': '卒業後も使えますか？',
  'materials.faq.2.answer': 'はい。実務に直結する内容のため、修了後の参考資料としてもご活用いただけます。',

  // CTASection
  'materials.cta.label': 'NEXT STEP',
  'materials.cta.title': 'さらに学びを深める',
  'materials.cta.body': '教材で学んだ内容をもとに、実際に身につくスキルやコースの詳細もぜひご確認ください。まずは無料の資料請求からお気軽にどうぞ。',
  'materials.cta.note': '※ご相談はオンラインでも承ります',
  'materials.cta.skills': '習得スキルを見る',
  'materials.cta.courses': 'コースを見る',
  'materials.cta.brochure': '資料請求はこちら（無料）',

  // RelatedPages
  'materials.related.label': 'LEARN MORE',
  'materials.related.title': '関連ページ',
  'materials.related.titleEn': 'Explore Further',
  'materials.related.viewLink': '詳しく見る',
  'materials.related.0.title': '習得スキル一覧',
  'materials.related.0.desc': '身につく5つのスキル領域',
  'materials.related.1.title': '実践トレーニング',
  'materials.related.1.desc': '実技とロールプレイング中心の訓練',
  'materials.related.2.title': 'カリキュラム概要',
  'materials.related.2.desc': '学びの全体像と進め方',
  'materials.related.3.title': 'コース一覧・比較',
  'materials.related.3.desc': '3コースの違いを一覧で確認',

  // Last updated
  'materials.lastUpdated': '最終更新: 2026年7月8日',
};

export default materials;
